import { memo } from 'react';

import type { ModelLead } from '@app/api/Leads/types';
import { ResponsibleSelect } from '@app/components/LeadCard/ui/ResponsibleSelect';

import { useLeadsRegistryResponsible } from '../../../../hooks/useLeadsRegistryResponsible';

import type { LeadsRegistryAssigneeOption } from '../../../../model/types';
import type { FC } from 'react';

interface LeadsRegistryResponsibleCellProps {
  lead: ModelLead;
  options: LeadsRegistryAssigneeOption[];
  isOptionsLoading?: boolean;
}

const LeadsRegistryResponsibleCellComponent: FC<
  LeadsRegistryResponsibleCellProps
> = ({ lead, options, isOptionsLoading = false }) => {
  const {
    employees,
    selectedEmployeeId,
    isResponsibleChanging,
    isResponsibleChangeDisabled,
    changeResponsible,
  } = useLeadsRegistryResponsible({ lead, options });

  return (
    <ResponsibleSelect
      employees={employees}
      selectedEmployeeId={selectedEmployeeId}
      mode="cell"
      showTitle={false}
      placeholder="Назначить"
      isLoading={isOptionsLoading || isResponsibleChanging}
      isDisabled={isResponsibleChangeDisabled}
      onSelect={changeResponsible}
    />
  );
};

export const LeadsRegistryResponsibleCell = memo(
  LeadsRegistryResponsibleCellComponent
);
